module.exports = __webpack_public_path__ + "static/media/game_background.3c029a5c.jpg";